import React from 'react';
import { Chart } from 'react-google-charts';

const MyPieChart = ({ tilesData }) => {
  const data = [
    ['Opportunities', 'All Open', 'Closed Won', 'Closed Lost'],
    ['Opportunities', tilesData[0]?.Value ?? 0, tilesData[2]?.Value ?? 0, tilesData[1]?.Value ?? 0]
  ];

  const options = {
    chartArea: { width: '60%' },
    hAxis: {
      title: 'Total Opportunities',
      minValue: 0
    },
    vAxis: {
      title: 'Count of All Open, Closed Won and Closed Lost '
    },
    legend: { position: 'top' },
    colors: ['#002A4E', '#50C0C0', '#404040'],
    bar: { groupWidth: '40%' }
  };

  return (
    <>
      <div
        style={{
          textAlign: 'center',
          fontSize: 24,
          fontWeight: 'bold',
          marginBottom: -25,
          color: '#000',
          marginTop: 50,
          zIndex: 1,
          position: 'sticky'
        }}
      >
        Total Opportunities
      </div>
      <Chart chartType="ColumnChart" data={data} options={options} width={'100%'} height={'500px'} />
    </>
  );
};

export default MyPieChart;
